import React, { useEffect, useState } from 'react';
import { Flex, Icon, Expandable, Block } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import GoalMatrixRowForm from './GoalMatrixRowForm';
import { capitalize } from 'helpers/content';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';
import { Collapsible, ColorLabel, ColorLabelContainer } from 'UI';
import './_OnlyFeedbackForm.scss';
import { utlGetLocalStorage } from '@microsoft/applicationinsights-common';

var DisplayOnlyFeedback = function DisplayOnlyFeedback(props) {
  var translate = useTranslate();
  var part = props.part,
      block = props.block;
  var assessment = block.api.getEditor().getProp('assessment');
  var isStudent = block.api.getEditor().getProp('isStudent');

  var renderAssessmentFeedbackPermission = function renderAssessmentFeedbackPermission() {
    var _props$part$permissio;

    var active = ((_props$part$permissio = props.part.permissions) === null || _props$part$permissio === void 0 ? void 0 : _props$part$permissio.find(function (element) {
      return element.target == 'GUARDIAN' && element.referenceType == 'ASSESSMENTFEEDBACK';
    })) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission active"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize('Show feedback for guardians'))));
  };

  var renderTitle = function renderTitle() {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic jcb"
    }, translate('Feedback'), !isStudent ? /*#__PURE__*/React.createElement("div", {
      className: "trigger-container"
    }, renderAssessmentFeedbackPermission()) : null);
  };

  var feedbacks = [];

  if (assessment != null) {
    var _assessment$assessmen;

    feedbacks = (_assessment$assessmen = assessment.assessmentFeedbacks) === null || _assessment$assessmen === void 0 ? void 0 : _assessment$assessmen.filter(function (feedback) {
      return feedback.assessmentBlockPartId == part.id;
    });
  }

  if (!isStudent) {
    return /*#__PURE__*/React.createElement("div", {
      className: "only-feedback-container"
    }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Flex, {
      space: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "title",
      style: {
        '--color': '#777'
      }
    }, translate('Feedback')), /*#__PURE__*/React.createElement("div", {
      className: "trigger-container"
    }, renderAssessmentFeedbackPermission()))));
  }

  if (isStudent && feedbacks != null && feedbacks.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "only-feedback-container"
    }, /*#__PURE__*/React.createElement(Expandable, {
      open: true,
      title: renderTitle(),
      color: "#777",
      ignorePropsUpdate: true
    }, feedbacks != null && feedbacks.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "feedbacks"
    }, feedbacks.map(function (feedback) {
      return /*#__PURE__*/React.createElement(Collapsible, {
        key: feedback.id,
        trigger: translate('Feedback'),
        defaultOpen: true
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: feedback.text
        }
      }));
    })) : null));
  }

  return null;
};

DisplayOnlyFeedback.defaultProps = {
  assessments: [],
  disabled: false
};
export default DisplayOnlyFeedback;